var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/pro-light-svg-icons";
export default function ErrorMessage(_a) {
    var _b = _a.explicitHeights, explicitHeights = _b === void 0 ? [0, 0, 0] : _b, message = _a.message;
    return (React.createElement(StyledLoader, { explicitHeights: explicitHeights },
        React.createElement("p", null,
            React.createElement(FontAwesomeIcon, { icon: faExclamationTriangle }),
            " Estamos trabajando para solucionarlo"),
        React.createElement("p", null, message)));
}
var StyledLoader = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  border-radius: ", ";\n  border: thin solid ", ";\n  clear: both;\n  color: ", ";\n  display: flex;\n  flex-direction: column;\n  font-size: 0.5rem;\n  justify-content: center;\n  overflow: hidden;\n  text-align: center;\n  width: 100%;\n\n  /*alto para desktop*/\n  height: ", ";\n  @media screen and (max-width: ", ") {\n    height: ", ";\n  }\n  @media screen and (max-width: ", ") {\n    height: ", ";\n  }\n"], ["\n  align-items: center;\n  border-radius: ", ";\n  border: thin solid ", ";\n  clear: both;\n  color: ", ";\n  display: flex;\n  flex-direction: column;\n  font-size: 0.5rem;\n  justify-content: center;\n  overflow: hidden;\n  text-align: center;\n  width: 100%;\n\n  /*alto para desktop*/\n  height: ", ";\n  @media screen and (max-width: ", ") {\n    height: ", ";\n  }\n  @media screen and (max-width: ", ") {\n    height: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.generalBorderRadius;
}, function (_a) {
    var theme = _a.theme;
    return theme.stop;
}, function (_a) {
    var theme = _a.theme;
    return theme.stop;
}, function (_a) {
    var explicitHeights = _a.explicitHeights;
    return explicitHeights[2] + "px";
}, function (_a) {
    var theme = _a.theme;
    return theme.mediumBreakPoint;
}, function (_a) {
    var explicitHeights = _a.explicitHeights;
    return explicitHeights[1] + "px";
}, function (_a) {
    var theme = _a.theme;
    return theme.smallMobileBreakPoint;
}, function (_a) {
    var explicitHeights = _a.explicitHeights;
    return explicitHeights[0] + "px";
});
var templateObject_1;
